<script lang="ts">
    import MainLayout from "../#common/layout/Layout.svelte"
    import {delay, navigate} from "src/components/cabinet/#common/helpers"
    import {doShow as showAlert} from "src/components/cabinet/#common/alert/store"
    import {getUserProfileByParams} from 'src/components/cabinet/#services/getUserProfile'
    import {getUserProfileByGpa} from 'src/components/cabinet/#services/getUserProfileByGpa'
    import {getUserProfileByNearWallet} from 'src/components/cabinet/#services/nearAdapter'
    import {getUserProfileByEvmWallet} from 'src/components/cabinet/#services/evmAdapter'
    import UAParser from 'ua-parser-js'

    const uAgent = UAParser(navigator.userAgent)

    let findBy = [
        { value: 'id', text: 'Support ID'},
        { value: 'email', text: 'Email'},
        { value: 'gpa', text: 'GPA'},
        { value: 'wallet', text: 'Wallet'},
        // { value: 'nickname', text: 'Nickname'},
    ];

    let selected = findBy[0].value
    let value = ''
    let searchSending = false
    let field
    let userId

    async function search() {
        const win = uAgent.browser.name.indexOf("Safari") >=0 ? window.open() : null

        value = value.trim()

        if (!selected || !value) {
            showAlert.set({
                status: 'error',
                text: 'You have not entered a value for the search'
            })
            return false
        }
        try {
            searchSending = true

            if (selected == "id" || selected == "email") {
                if (value.includes('@')) {
                    userId =  await getUserProfileByParams.request({ data: { email: value.toLowerCase() } })
                } else {
                    userId = value
                }
            }
            if (selected == "nickname") {
                userId =  await getUserProfileByParams.request({ data: { nickname: value } })
            }
            if (selected == "eth") {
                userId =  await getUserProfileByParams.request({ data: { ethWallet: value } })
            }
            if (selected == "wallet") {
                if (value.startsWith('0x')) {
                    userId =  await getUserProfileByEvmWallet.request({ data: { publicKey: value } })
                } else {
                    userId =  await getUserProfileByNearWallet.request({ data: { accountId: value } })
                }
            }
            if (selected == "gpa") {
                userId =  await getUserProfileByGpa.request({ data: { gpa: value } })
            }

            if (uAgent.browser.name.indexOf("Safari") >= 0) {
                win.location.href = '/profile/' + userId
                return
            } else {
                const desk = window.open()
                desk.location.href = ('/profile/' + userId)
                return
            }
        } catch (err) {
            if (err.message) {
                showAlert.set({
                    status: 'error',
                    text: err.message
                })
            } else {
                showAlert.set({
                    status: 'error',
                    text: 'An Error Occurred, Please Try Again Later'
                })
            }
        } finally {
            searchSending = false
        }
    }
</script>

<svelte:head>
    <title>Users</title>
</svelte:head>

<MainLayout title="Users">
    <svelte:fragment slot="content">
        <div class="card">
            <div class="card-body">
                <form class="panel" on:submit|preventDefault={search} novalidate>
                    <label>Find user by</label>
                    <div class="input-group mb-3 filter">
                        <select class="form-select" bind:value={selected}>
                            {#each findBy as item}
                                <option value={item.value}>
                                    {item.text}
                                </option>
                            {/each}
                        </select>
                        <input type="text" class="form-control" bind:value={value} {field} placeholder="Enter value..." autofocus>
                        <button type="submit" class="btn btn-primary" class:loading={searchSending} disabled={searchSending}>Search</button>
                    </div>
                </form>
            </div>
        </div>
    </svelte:fragment>
</MainLayout>

<style>
    .filter {
        max-width: 600px;
    }

    .filter input {
        width: auto;
    }

    .filter select {
        width: 150px;
        min-width: 150px;
        max-width: 150px;
    }

    @media(max-width: 767px) {
        .filter {
            max-width: 100%;
        }

        .filter input,
        .filter select,
        .filter .btn {
            margin-bottom: 10px;
            border-radius: 4px !important;
            display: block;
            width: 100%;
            min-width: 100%;
            max-width: 100%;
        }
    }
</style>
